import React, { useEffect } from "react";
import { Route, useLocation } from "react-router-dom";
import {
  ActionLogIndex,
  BackupAndRestoreIndex,
  CertificationCalenderTracker,
  CompanyInfoIndex,
  DepartmentIndex,
  EmailSetupIndex,
  MainAdminSettings,
  RoleIndex,
  StandardResettingIndex,
  SubcriptionIndex,
  UserManagementIndex,
  UserRoleIndex,
  VendorManagement,
} from "../pages/AdminSettings";

function AdminSettingsRoutes() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin-settings") {
      window.location.replace("/admin-settings/company-info");
    }
  }, [location]);
  return (
    <Route path="admin-settings" element={<MainAdminSettings />}>
      <Route path="company-info" element={<CompanyInfoIndex />} />
      <Route path="email-setup" element={<EmailSetupIndex />} />
      <Route path="user-managment" element={<UserManagementIndex />} />
      <Route path="role" element={<UserRoleIndex />} />
      <Route path="user-role" element={<RoleIndex />} />
      <Route path="standard-reset" element={<StandardResettingIndex/>} />
      <Route path="action-log" element={<ActionLogIndex/>} />
      <Route path="vendor-management" element={<VendorManagement/>} />
      <Route
        path="certification-calendar-tracker"
        element={<CertificationCalenderTracker/>}
      />
      <Route path="subcription" element={<SubcriptionIndex/>} />
      <Route path="department-type" element={<DepartmentIndex/>} />
      <Route path="backup-restore" element={<BackupAndRestoreIndex/>} />
    </Route>
  );
}

export default AdminSettingsRoutes;
